module.exports = __webpack_public_path__ + "img/site_21_pb.35663978.png";